import React, { createContext, useState } from 'react';

// Create the UserContext
export const UserContext = createContext();

// Create the UserProvider component
export const UserProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);  // Manages loader visibility
  const [loading2, setLoading2] = useState(false);  // Manages loader visibility

  // Function to toggle the loader
  const toggleLoader = (isLoading) => {
    setLoading(isLoading);
  };
  const toggleLoader2 = (isLoading2) => {
    setLoading2(isLoading2);
  };

  return (
    <UserContext.Provider value={{ loading, toggleLoader, loading2, toggleLoader2 }}>
      {children}
    </UserContext.Provider>
  );
};